import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ActivityReportInternshipLocationUseCaseInterface } from 'domain/usecases';

interface IActivityReportInternship {
  activityReportInternship: ActivityReportInternshipLocationUseCaseInterface.Result[];
}

interface IPayloadActivityReportInternship
  extends PayloadAction<
    ActivityReportInternshipLocationUseCaseInterface.Result[]
  > {}

const initialState: IActivityReportInternship = {
  activityReportInternship: null,
};

export const ActivityReportInternshipSlice = createSlice({
  name: 'activity-report-internship',
  initialState,
  reducers: {
    loadActivityReportInternship: (
      state,
      action: IPayloadActivityReportInternship,
    ) => {
      state.activityReportInternship = action.payload;
    },
    clearLoadActivityReportInternship: (state) => {
      state.activityReportInternship = null;
    },
  },
});

export const {
  loadActivityReportInternship,
  clearLoadActivityReportInternship,
} = ActivityReportInternshipSlice.actions;

export default ActivityReportInternshipSlice.reducer;
